import { c as _c } from "react-compiler-runtime";
import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { CopyButton } from 'foundations-components/transitional/components/CopyButton';
import { sanitize } from 'sanitize-text/sanitizers/Sanitize';
import { config as sanitizerConfig } from 'sanitize-text/sanitizers/SanitizeConfiguration';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PublicRecapTab = t0 => {
  const $ = _c(12);
  const {
    summaryHtml
  } = t0;
  let t1;
  if ($[0] !== summaryHtml) {
    t1 = sanitize(summaryHtml, sanitizerConfig.HTML);
    $[0] = summaryHtml;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const sanitizedHtml = t1;
  let tempDiv;
  if ($[2] !== sanitizedHtml) {
    tempDiv = document.createElement("div");
    tempDiv.innerHTML = sanitizedHtml;
    $[2] = sanitizedHtml;
    $[3] = tempDiv;
  } else {
    tempDiv = $[3];
  }
  const plainText = tempDiv.textContent || "";
  let t2;
  if ($[4] !== sanitizedHtml) {
    t2 = /*#__PURE__*/_jsx("div", {
      dangerouslySetInnerHTML: {
        __html: sanitizedHtml
      }
    });
    $[4] = sanitizedHtml;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "external-sharing-components.recapTab.copyToClipboard"
    });
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== plainText) {
    t4 = /*#__PURE__*/_jsx(Flex, {
      children: /*#__PURE__*/_jsx(CopyButton, {
        size: "small",
        use: "secondary",
        value: plainText,
        hint: "",
        children: t3
      })
    });
    $[7] = plainText;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "200",
      children: [t2, t4]
    });
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};